module.exports = __webpack_public_path__ + "img/reject.da702ae4.png";